import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInsuredPersonsState, IPolicies, TError } from './types/InsuredPersons-interface';
import { fetchInsuredPersonsList, fetchPoliciesDownload } from './actions/fetch-insured-persons';


const initialState: IInsuredPersonsState = {
    Policies: [],
    PolicyCount: 0,
    isLoadingPolicies: false,
    errorPolicies: [],
    lastFetchTime: null,
    contractID: [],
    currentPage: 1,
    currentPageInCase: 1,
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: ""
};

export const insuredPersonsList = createSlice({
    name: 'insuredPersonsList',
    initialState,
    reducers: {
        resetListInsuredPersons: (state) => {
            state.Policies = [];
            state.PolicyCount = 0;
            state.isLoadingPolicies = false;
            state.errorPolicies = [];
            state.lastFetchTime = null;
            state.contractID = [];
            state.currentPage = 1;
            state.currentPageInCase = 1;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
        setCurrentPageInsuredPersons: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPage = action.payload.page;
        },
        setCurrentPageInCaseInsuredPersons: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPageInCase = action.payload.page;
        },
        resetFileData: (state) => {
            state.Policies = state.Policies;
            state.PolicyCount = state.PolicyCount;
            state.errorPolicies = state.errorPolicies;
            state.isLoadingPolicies = state.isLoadingPolicies;
            state.lastFetchTime = state.lastFetchTime;
            state.currentPage = state.currentPage;
            state.contractID = state.contractID;
            state.currentPageInCase = state.currentPageInCase;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInsuredPersonsList.pending, (state) => {
                state.isLoadingPolicies = true;
            })
            .addCase(fetchInsuredPersonsList.fulfilled, (state, action: PayloadAction<{ policies: IPolicies[], policyCount: number, fetchTime: number, contractID: string[] | [] }>) => {
                state.isLoadingPolicies = false;
                state.Policies = action.payload.policies;
                state.PolicyCount = action.payload.policyCount;
                state.errorPolicies = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.contractID = action.payload.contractID;
                state.currentPage = state.currentPage;
                state.currentPageInCase = state.currentPageInCase;
            })
            .addCase(fetchInsuredPersonsList.rejected, (state, action) => {
                state.Policies = [];
                state.isLoadingPolicies = false;
                state.errorPolicies = action.payload as TError;
                state.contractID = [];
                state.currentPage = 1;
                state.currentPageInCase = 1;
            })
            .addCase(fetchPoliciesDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchPoliciesDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownload = [];
            })
            .addCase(fetchPoliciesDownload.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownload = false;
                state.errorDownload = action.payload as TError;
            });
    },
});

export const { resetListInsuredPersons, setCurrentPageInsuredPersons, setCurrentPageInCaseInsuredPersons, resetFileData } = insuredPersonsList.actions;
export default insuredPersonsList.reducer;